// cookie used in root page of elis-registration for skipping e-mail login form
export const ROSSUM_APP_DOMAIN = 'rossum-app-domain';
